// JavaScript Document

// Scripts written by Jordan Bearce @ Weblinx, Inc.

const catSelectSource = document.querySelector(".weblinx-menu-list--categories");
const selectMenu = document.querySelector("#sidebar_cat_selector");

function activateSelect(catOptions, selectMenu) {
    if (catOptions && selectMenu) {
        document.querySelector(".sidebar__selector").classList.remove("__visuallyhidden");
        catOptions.forEach((option) => {
            console.log(option);
            // for each option, append it to selectMenu as an `option` element
            const is_selected = option.classList.contains("weblinx-menu-list__link--current");

            // create a new option element
            const newOption = document.createElement("option");
            // set the text content of the option to the inner text of the catOption
            newOption.textContent = option.innerText;
            // set the value of the option to the href of the catOption
            newOption.value = option.getAttribute("href");
            // check if the catOption is selected
            if (is_selected) {
                // set the selected attribute of the option to true
                newOption.selected = true;
            }
            // append the new option to the selectMenu
            selectMenu.appendChild(newOption);
        });
    }
}

if (catSelectSource) {
    const catOptions = catSelectSource.querySelectorAll(".weblinx-menu-list__link");

    activateSelect(catOptions, selectMenu);

    // once activateSelect finishes, set up an event listener to fire when the select changes.
    selectMenu.addEventListener("change", function () {
        // get the selected option
        const selectedOption = selectMenu.options[selectMenu.selectedIndex];
        // get the value of the selected option
        const selectedValue = selectedOption.value;
        window.open(selectedValue, "_self");
    });
}
